import React from 'react';
import PropTypes from 'prop-types';

// Atoms
import {
	MenuBottomExtension, MenuButtonLink,
	MenuLink, MenuLinkWrapper,
	MenuWrapper,
} from './Menu.atoms';

const Menu = (props) => {
	const { links } = props;

	const renderLinks = link => (
		<MenuLinkWrapper key={link.name}>
			<MenuBottomExtension />
			<MenuLink
				duration={0.4}
				key={link.name}
				to={link.to}
				href={link.to}
				activeClassName="active"
				partiallyActive
			>
				{link.node || link.name}
			</MenuLink>
		</MenuLinkWrapper>
	);

	return (
		<>
			<MenuWrapper>
				{links.map(link => (renderLinks(link)))}
				<MenuButtonLink
					duration={0.4}
					target="_blank"
					href="https://fatcatcoders.com/contact"
				>
					Contact us
				</MenuButtonLink>
			</MenuWrapper>
		</>
	);
};

Menu.propTypes = {
	links: PropTypes.arrayOf(PropTypes.shape({
		to: PropTypes.string,
		name: PropTypes.string,
		node: PropTypes.node,
	})).isRequired,
};

export default Menu;
